export type OnboardingTeamMemberDraft = {
  email: string;
  role_slugs: string[];
};

export const DEFAULT_ONBOARDING_TEAM_ROLE_SLUGS = [
  'member',
  'rogerdocs:dashboard',
  'coder',
  'intake',
] as const;
